<template>
  <!-- <div id="login">
    <div id="loginShade" :class="(mobile) ? 'wid90' : 'wid50'"></div>
    <div id="loginBox" class="row" :class="(mobile) ? 'wid90' : 'wid50'">
      <div class="col-12 col-md-1"></div>
      <div class="col-12 col-md-10 toCenter">
        <h1 style="font-size: 40px;">Sign In</h1>
        <p style="background-color:red;font-weight:bold;padding:5px" v-if="error != ''">{{error}}</p>
        <div class="form">
          <div class="mt-4">
            <label class="sr-only">Username</label>
            <div class="input-group mb-2">
              <div class="input-group-prepend">
                <div class="input-group-text" style="background-color: #FCC514; width:60px;">
                  <i class="fas fa-user fa-2x" style="margin: 0 auto;"></i>
                </div>
              </div>
              <input v-model="user.username" type="text" placeholder="Username" class="form-control login-input" @keyup.enter="login">
            </div>
          </div>
          <div class="mt-4">
            <label class="sr-only">Password</label>
            <div class="input-group mb-2">
              <div class="input-group-prepend">
                <div class="input-group-text" style="background-color: #FCC514; width:60px;">
                  <i class="fas fa-key fa-2x" style="margin: 0 auto;"></i>
                </div>
              </div>
              <input v-model="user.password" type="password" placeholder="Password" class="form-control login-input" @keyup.enter="login">
            </div>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col" style="display: flex; flex-direction: row-reverse;" :class="(mobile) ? '' : 'mr-5'">
            <div :style="(mobile) ? 'width: 100%' : 'width: 20%'">
              <button type="button" class="btn btn-warning w-100" style="font-size: 150%;" @click="login">Masuk</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div> -->
  <div class="login-no-overflow">
    <div class="row" style="height:100vh">
      <div :class="{'col-md-5' : !mobile}" class="login-background h-100">

      </div>
      <div class="flexify bg-white " :class="{'col-md-7' : !mobile , 'col-12 login-background' : mobile}">
        <div class="loginBox bg-white" :class="{'p-40 shadow rounded' : mobile}">
          <span class="title">Login</span><br>
          <span class="company">{{ company.fullname }}</span>
          <br>
          <br>
          <span class="subtitle" v-if="!mobile">Please Enter Username and Password to Access this system.</span>

          <p class="subtitle" style="background-color:red;font-weight:bold;" v-if="error != ''">{{error}}</p>

          <div class="form">
            <div class="mt-4">
              <label class="sr-only">Username</label>
              <div class="input-group">
                <div class="input-group-prepend">
                  <div class="input-group-text bg-white" style="width:60px;">
                    <i class="fas fa-user fa-2x" style="margin: 0 auto;"></i>
                  </div>
                </div>
                <input v-model="user.username" type="text" placeholder="Username" class="form-control login-input" @keyup.enter="login">
              </div>
            </div>
            <div class="mt-2">
              <label class="sr-only">Password</label>
              <div class="input-group">
                <div class="input-group-prepend">
                  <div class="input-group-text bg-white" style="width:60px;">
                    <i class="fas fa-key fa-2x" style="margin: 0 auto;"></i>
                  </div>
                </div>
                <input v-model="user.password" type="password" placeholder="Password" class="form-control login-input" @keyup.enter="login">
              </div>
            </div>
          </div>

          <div class="w-100 shadow mt-3">
            <button type="button" class="btn btn-login-color w-100" style="font-size: 150%;" @click="login">Login</button>
          </div>

          <div class="w-100" style="bottom: 1em;position:absolute;">
            <h5>SCS Version {{buildVersion}}</h5>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">

import PageOptions from '@/Options/PageOptions.js'
import jquery from 'jquery';

const buildVersion = require('./../../../package.json').version

export default {
  metaInfo: {
    title: 'Login',
    titleTemplate: '%s',
    htmlAttrs: {
      lang: 'en',
      amp: true
    }
  },
	name: 'Login',
	data() {
		return {
      buildVersion : buildVersion,
			user: {
				username: '',
				password: '',
			},
      error: '',
      mobile : this.isMobile(),
      company : null

		}
	},
  created() {
    this.$http.get('/api/v1/auth/company')
    .then((resp) => {
      this.company = resp.data.data
    })
    .catch((err) => {
      console.log(err)
    })
  },
	mounted() {
    if(this.$store.state.warningMessage) {
			this.error = this.$store.state.warningMessage
			this.$store.state.warningMessage = null
		}
    console.log(this.$store.state , this.mobile)

    
	},
	methods: {
		login: function() {

      this.$http.post('/api/v1/auth' , this.user)
      .then((resp)=>{
        this.error = ''
        var user = resp.data.data;
        // console.log(resp)

        this.$http.defaults.headers.common['Authorization'] = "Bearer " + user.token;

        console.log()
        this.$store.state.showPendingBarang = true
        user.name = this.user.username

        // const companyDetails = {
        //   company : companyName,
        //   companyLogo : companyLogo
        // }

        this.$store.dispatch('setUser', user);
        // this.$store.dispatch('setCompanyDetails', companyDetails);
      })
      .then(async ()=>{
        let modules = await this.getModules();
        await this.loadFilterOptions();

        console.log(modules ? 'Modules Successfully Loaded' : 'Modules Has Failed To Load');
      })
      .then(()=>{
        var user = this.$store.getters.currentUser
        var allowed_roles = ['ADMIN']

        
        
        if (
          user.permissions.indexOf('form.home.fullAccess') != -1 ||
          user.role.length == 0 ||
          user.role[0].id == 1
        ){
          if(this.$store.state.routeBeforeAuth) {
            this.$router.push(this.$store.state.realUrl)
            this.$store.state.routeBeforeAuth = null
          }
          else {
            this.$router.push({name : 'Homepage'})
          }
        }
        else if (user.role[0].name == 'Warna') {
          this.$router.push({name : 'WorkOrderListing'})
        }
        else if (user.role[0].name == 'Tanda Terima Only') {
          this.$router.push({name : 'WorkOrderFormNew'})
          PageOptions.pageWithoutSidebar = true
        } else{
          if(this.$store.state.routeBeforeAuth) {
            this.$router.push(this.$store.state.realUrl)
            this.$store.state.routeBeforeAuth = null
          }
          else {
            this.$router.push({name : 'Welcome'})
          }
        }
          
      })
      .catch((err)=>{
        console.log(err)
        this.error = 'Username or Password is Invalid';
        this.user.password = ''
      })

      // this.$store.dispatch('setUser', {
      //   user_id: 2,
      //   username: 'andre',
      //   fullname: 'Andre',
      //   role: 'ADMINISTRATOR',
      // });
      // this.$router.push({name : 'Home'});
    },
	}
}
</script>

<style scoped>
  .login-background{
    height: 100vh;
    background: url('~@/assets/img/Login/458 fr.jpeg');
    background-repeat: no-repeat;
    /* background-position: 50% 50%; */
    background-size: cover;
    position: relative;
  }

  .toCenter{
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .wid50{ width: 50vw; }
  .wid90{ width: 90vw; }

  #loginShade{
    position: absolute;
    top:50%; left:50%;
    transform: translate(-50%, -50%);

    height: 400px;

    margin: 0 auto;

    background-color: black;
    opacity: 0.5;
    border-radius: 7px;
  }

  .loginBox{
    min-height: 200px;
    width: 90%;

    margin: 0 auto;
    padding: 2%;
    color:black;
  }

  .login-input{
    height:50px;
  }

  .login-input::placeholder{
    font-size: 130%;
    font-weight: bold;
  }

  .flexify {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .title {
    font-size : 4em;
  }
  .company {
    font-size: 2em;
  }

  .subtitle {
    font-size: 1.5em;
  }

  .input-group {
    padding : 10px 0px 10px 
  }

  .btn-login-color {
    background-color : rgb(255, 174, 0);
    color : white;
  }

  .login-no-overflow {
    overflow: hidden;
  }
</style>